import { createSlice } from "@reduxjs/toolkit";
import editPrice from "@custom/rtk-apis/price/editPrice";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const editPriceSlice = createSlice({
  name: "editPrice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editPrice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editPrice.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(editPrice.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default editPriceSlice.reducer;
export const { closeModal } = editPriceSlice.actions;
